// State + transitions for the Handicap Server Summary widget. Consolidates the
// async load and the UI state (search query, selected player) into a single
// reducer (REACT-093); the data-fetching action itself lives in hooks.js so it
// stays out of the component body (REACT-089).

export const INITIAL_STATE = {
  loading: true,
  error: null,
  summary: null,
  searchQuery: '',
  selectedPlayer: null,
}

// Private: every transition is reached through an action creator below, so the
// types stay an implementation detail of this module.
const ACTION_TYPES = {
  LOAD_START: 'LOAD_START',
  LOAD_SUCCESS: 'LOAD_SUCCESS',
  LOAD_ERROR: 'LOAD_ERROR',
  SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  SET_SELECTED_PLAYER: 'SET_SELECTED_PLAYER',
}

export const summaryReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.LOAD_START:
      return { ...state, loading: true, error: null }
    case ACTION_TYPES.LOAD_SUCCESS:
      return { ...state, loading: false, summary: action.summary }
    case ACTION_TYPES.LOAD_ERROR:
      return { ...state, loading: false, error: action.error }
    case ACTION_TYPES.SET_SEARCH_QUERY:
      return { ...state, searchQuery: action.value }
    case ACTION_TYPES.SET_SELECTED_PLAYER:
      return { ...state, selectedPlayer: action.value }
    default:
      return state
  }
}

// Action creators — callers dispatch through these rather than building action
// objects, matching member_handicap_history/actions.js (dispatch first).

export const loadStart = (dispatch) => dispatch({ type: ACTION_TYPES.LOAD_START })

export const loadSuccess = (dispatch, summary) => dispatch({ type: ACTION_TYPES.LOAD_SUCCESS, summary })

export const loadError = (dispatch, error) => dispatch({ type: ACTION_TYPES.LOAD_ERROR, error })

export const setSearchQuery = (dispatch, value) => dispatch({ type: ACTION_TYPES.SET_SEARCH_QUERY, value })

export const setSelectedPlayer = (dispatch, value) => dispatch({ type: ACTION_TYPES.SET_SELECTED_PLAYER, value })

// Selector — filtering is derived from state, never done in the component (REACT-092).
export const getFilteredPlayers = (players, searchQuery) =>
  players.filter((p) => p.name.toLowerCase().includes(searchQuery.toLowerCase()))
